import { z } from 'zod';
import { exportPreferenceFields } from './export-preferences.mjs';
import { boundedSchema, digest, id, text, unique } from './common.mjs';

const routeSchema = z
  .object({
    id,
    path: z
      .string()
      .max(500)
      .refine((s) => s.startsWith('/') && !s.startsWith('//') && !/[?#\\\u0000-\u0020]/.test(s)),
    title: text(200),
  })
  .strict();
// Handles are resolved by SES/RUN under current authority, never fetched as
// arbitrary URLs. Source inventories are editor-only projections.
export const readOnlyReactPayloadSchema = boundedSchema(
  z
    .object({
      ...exportPreferenceFields,
      schemaVersion: z.literal(1),
      id,
      title: text(300),
      sourceDigest: digest,
      bundleDigest: digest,
      inventoryRef: id,
      runtimeRef: id,
      homeRouteId: id,
      routes: z.array(routeSchema).min(1).max(100),
      readBindingRefs: z.array(id).max(100),
      capabilities: z
        .object({
          collections: z.literal(false),
          externalWrites: z.literal(false),
          serverFunctions: z.literal(false),
        })
        .strict(),
    })
    .strict()
    .superRefine((v, ctx) => {
      unique(
        v.routes.map((r) => r.id),
        ctx,
        ['routes'],
      );
      unique(
        v.routes.map((r) => r.path),
        ctx,
        ['routes'],
      );
      unique(v.readBindingRefs, ctx, ['readBindingRefs']);
      if (!v.routes.some((r) => r.id === v.homeRouteId))
        ctx.addIssue({ code: 'custom', path: ['homeRouteId'], message: 'Unknown home route' });
    }),
);
